import React, {forwardRef, useCallback, useMemo, useState} from 'react';
import Button from "@/components/common/Buttons/Button";
import {MODAL_VARIANT} from "@/constants";
import dynamic from "next/dynamic";

const MODAL_COMPONENT = {
	[MODAL_VARIANT.TEXT]:
		dynamic(() => import('@/components/ModalVariants/TextModal'), { ssr: false }),
	[MODAL_VARIANT.NEW_TAB]:
		dynamic(() => import('@/components/ModalVariants/OpenInNewWindowModal'), { ssr: false }),
	[MODAL_VARIANT.VIDEO]:
		dynamic(() => import('@/components/ModalVariants/VideoModal'), { ssr: false }),
	[MODAL_VARIANT.AUDIO]:
		dynamic(() => import('@/components/ModalVariants/AudioModal'), { ssr: false }),
}

const ModalButton = forwardRef(function ModalButton({
	children,
	modalVariant=MODAL_VARIANT.TEXT,
	modalProps={},
	...props
}, fref){
	const [modalOpen, setModalOpen] = useState(false)
	const Modal = useMemo(() => MODAL_COMPONENT?.[modalVariant] || MODAL_COMPONENT[MODAL_VARIANT.TEXT],[modalVariant])

	const handleModalOpen = useCallback(() => {
		setModalOpen(true)
	},[])

	const handleModalClose = useCallback(() => {
		setModalOpen(false)
	},[])


	return (
		<>
			<Button ref={fref} onClick={handleModalOpen} noHoverEffect  {...props}>
				{children}
			</Button>
			<Modal isOpen={modalOpen} handleClose={handleModalClose} {...modalProps}/>
		</>
	)
})

export default ModalButton;
